import { Link } from "found";
import React, { useMemo } from "react";

const DesignProofPreview = ({ proof, height, width }) => {
  const { src, alt } = useMemo(() => ({
    alt: "Preview of a design proof",
    src: proof?.asset?.url?.formatted
  }), [proof]);

  return (
    <Link to={src} target="_blank" rel="noopener">
      <img
        alt={alt}
        src={src}
        style={height && width ? { height, objectFit: "contain", width } : {}}
      />
    </Link>
  );
};

export default DesignProofPreview;
